// src/utils/socialApi.js
// Client API centralise pour Fynho Social - toutes les fonctions appellent /endpoints/social.php

import apiClient from '../api/client';

const BASE = '/endpoints/social.php';

// ---------------- AUTH ----------------
export const register = (email, password) =>
  apiClient.post(`${BASE}?action=register`, { email, password });

export const login = (email, password) =>
  apiClient.post(`${BASE}?action=login`, { email, password });

export const forgotPassword = (email) =>
  apiClient.post(`${BASE}?action=forgot_password`, { email });

export const resetPassword = (token, newPassword) =>
  apiClient.post(`${BASE}?action=reset_password`, { token, new_password: newPassword });

// ---------------- PROFIL ----------------
export const checkUsername = (username) =>
  apiClient.get(`${BASE}?action=check_username&username=${encodeURIComponent(username)}`);

export const createProfile = (profileData) =>
  apiClient.post(`${BASE}?action=create_profile`, profileData);

export const getProfile = (userId) =>
  apiClient.get(`${BASE}?action=get_profile&user_id=${userId}`);

export const updatePresence = (userId, isOnline) =>
  apiClient.post(`${BASE}?action=update_presence`, { user_id: userId, is_online: isOnline });

// ---------------- CARTE / RECHERCHE ----------------
export const getMapUsers = (city, userId) =>
  apiClient.get(`${BASE}?action=map_users&city=${encodeURIComponent(city)}&user_id=${userId}`);

export const searchUser = (username) =>
  apiClient.get(`${BASE}?action=search_user&username=${encodeURIComponent(username)}`);

// ---------------- INVITATIONS / AMIS ----------------
export const sendFriendRequest = (senderId, receiverId) =>
  apiClient.post(`${BASE}?action=send_request`, { sender_id: senderId, receiver_id: receiverId });

export const respondFriendRequest = (requestId, response) =>
  apiClient.post(`${BASE}?action=respond_request`, { request_id: requestId, response });

export const listFriendRequests = (userId) =>
  apiClient.get(`${BASE}?action=list_requests&user_id=${userId}`);

export const listFriends = (userId) =>
  apiClient.get(`${BASE}?action=list_friends&user_id=${userId}`);

export const removeFriend = (userId, friendId) =>
  apiClient.post(`${BASE}?action=remove_friend`, { user_id: userId, friend_id: friendId });

export const blockUser = (userId, blockedId) =>
  apiClient.post(`${BASE}?action=block_user`, { user_id: userId, blocked_id: blockedId });

// ---------------- CHAT PRIVE ----------------
export const sendMessage = (senderId, receiverId, content, imageUrl, isEphemeral) =>
  apiClient.post(`${BASE}?action=send_message`, {
    sender_id: senderId, receiver_id: receiverId, content,
    image_url: imageUrl, is_ephemeral: isEphemeral,
  });

export const getMessages = (userId, friendId, afterId = 0) =>
  apiClient.get(`${BASE}?action=get_messages&user_id=${userId}&friend_id=${friendId}&after_id=${afterId}`);

export const openEphemeral = (messageId) =>
  apiClient.post(`${BASE}?action=open_ephemeral`, { message_id: messageId });

export const deleteMessage = (messageId, userId) =>
  apiClient.post(`${BASE}?action=delete_message`, { message_id: messageId, user_id: userId });

// ---------------- EVENEMENTS ----------------
export const listEvents = (city, userId) =>
  apiClient.get(`${BASE}?action=list_events${city ? `&city=${encodeURIComponent(city)}` : ''}${userId ? `&user_id=${userId}` : ''}`);

export const createEvent = (eventData) =>
  apiClient.post(`${BASE}?action=create_event`, eventData);

export const joinEvent = (eventId, userId, secretCode) =>
  apiClient.post(`${BASE}?action=join_event`, { event_id: eventId, user_id: userId, secret_code: secretCode });

export const leaveEvent = (eventId, userId) =>
  apiClient.post(`${BASE}?action=leave_event`, { event_id: eventId, user_id: userId });

export const cancelEvent = (eventId, userId) =>
  apiClient.post(`${BASE}?action=cancel_event`, { event_id: eventId, user_id: userId });

export const getEventMessages = (eventId, afterId = 0) =>
  apiClient.get(`${BASE}?action=get_event_messages&event_id=${eventId}&after_id=${afterId}`);

export const sendEventMessage = (eventId, senderId, content, imageUrl) =>
  apiClient.post(`${BASE}?action=send_event_message`, {
    event_id: eventId, sender_id: senderId, content, image_url: imageUrl,
  });

// ---------------- SIGNALEMENTS ----------------
export const reportContent = (reporterId, targetType, targetId, reason) =>
  apiClient.post(`${BASE}?action=report`, {
    reporter_id: reporterId, target_type: targetType, target_id: targetId, reason,
  });

// ---------------- ADMIN ----------------
export const adminDeleteEvent = (eventId) =>
  apiClient.post(`${BASE}?action=admin_delete_event`, { event_id: eventId });

export const adminHideEvent = (eventId) =>
  apiClient.post(`${BASE}?action=admin_hide_event`, { event_id: eventId });

export const adminListEvents = () =>
  apiClient.get(`${BASE}?action=admin_list_events`);

export const adminListReports = (status = 'open') =>
  apiClient.get(`${BASE}?action=admin_list_reports&status=${status}`);

export const adminReviewReport = (reportId, status) =>
  apiClient.post(`${BASE}?action=admin_review_report`, { report_id: reportId, status });

export const adminDeleteMessage = (messageId, messageType) =>
  apiClient.post(`${BASE}?action=admin_delete_message`, { message_id: messageId, message_type: messageType });

export const adminBanUser = (userId) =>
  apiClient.post(`${BASE}?action=admin_ban_user`, { user_id: userId });

export const adminUnbanUser = (userId) =>
  apiClient.post(`${BASE}?action=admin_unban_user`, { user_id: userId });